
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Get root element
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// Create root and render app immediately
const root = createRoot(rootElement);
root.render(<App />);

// Preload critical resources after initial render
requestIdleCallback(() => {
  // Preload critical route components
  import('./pages/BaremetalServers');
  import('./pages/VPSServers');
  import('./pages/ResidentialProxies');
}, { timeout: 2000 });
